export const routePaths = {
  home: { path: '/', name: 'common:route.home' },
  // workflow
  workflowCases: {
    path: '/workflow/cases',
    name: 'common:route.workflowCases',
  },
  workflowCaseDetail: {
    path: '/workflow/cases/:caseId',
    name: 'common:route.workflowCaseDetail',
  },
  workflowAutoExecutionHistory: {
    path: '/workflow/auto-execution-history',
    name: 'common:route.workflowAutoExecutionHistory',
  },
  // demand
  demandForecastList: {
    path: '/demand/forecast-list',
    name: 'common:route.demandForecastList',
  },
  // workflow linked-page 専用の未実装 route (menu / implementedPages 非経由)。
  // LINKED_PAGE_KIND_MAP の DEMAND_ACTUAL_STATISTICS から参照される (models/linkedPage.ts)。
  demandActualStatistics: {
    path: '/demand/actual-statistics',
    name: 'common:route.demandActualStatistics',
  },
  demandForecastDaily: {
    path: '/demand/forecast-daily',
    name: 'common:route.demandForecastDaily',
  },
  // workflow linked-page 専用の未実装 route (週間の需要想定画面 = map #13178 Slice 2 が
  // 同じ path に画面を載せる)。 LINKED_PAGE_KIND_MAP の DEMAND_FORECAST_DAILY の週間 variant から参照される。
  demandForecastWeekly: {
    path: '/demand/forecast-weekly',
    name: 'common:route.demandForecastWeekly',
  },
  // supply
  supplyBilateral: {
    path: '/supply/bilateral',
    name: 'common:route.supplyBilateral',
  },
  supplyPlant: { path: '/supply/plant', name: 'common:route.supplyPlant' },
  supply48Data: { path: '/supply/48data', name: 'common:route.supply48Data' },
  supplyRenewForecast: {
    path: '/supply/renew-forecast',
    name: 'common:route.supplyRenewForecast',
  },
  supplyGap: { path: '/supply/gap', name: 'common:route.supplyGap' },
  // bidding
  biddingSpot: { path: '/bidding/spot', name: 'common:route.biddingSpot' },
  // スポット入札 CSV インポート (= スポット入札画面の子ページ。
  // spec spot-bid-normal-csv-import.md §5 / spot-bid-block-csv-import.md §6。 種別は ?kind=normal|block)。
  biddingSpotCsvImport: {
    path: '/bidding/spot/csv-import',
    name: 'common:route.biddingSpotCsvImport',
  },
  biddingIntraday: {
    path: '/bidding/intraday',
    name: 'common:route.biddingIntraday',
  },
  // 時間前入札 CSV インポート (= 時間前入札画面の子ページ。
  // spec intraday-csv-import.md §6。 スポットと違い種別クエリを持たない)。
  biddingIntradayCsvImport: {
    path: '/bidding/intraday-csv-import',
    name: 'common:route.biddingIntradayCsvImport',
  },
  biddingSpotPrice: {
    path: '/bidding/spot-price',
    name: 'common:route.biddingSpotPrice',
  },
  // 清算 (JEPX の清算書の一覧。 spec bidding/jepx-settlement.md)。
  biddingSettlement: {
    path: '/bidding/settlement',
    name: 'common:route.biddingSettlement',
  },
  biddingImbalancePrice: {
    path: '/bidding/imbalance-price',
    name: 'common:route.biddingImbalancePrice',
  },
  biddingSupplyCapacityChange: {
    path: '/bidding/supply-capacity-change',
    name: 'common:route.biddingSupplyCapacityChange',
  },
  // plan
  planSubmission: {
    path: '/plan/submission',
    name: 'common:route.planSubmission',
  },
  submissionManagement: {
    path: '/submission-management',
    name: 'common:route.submissionManagement',
  },
  planProcurement: {
    path: '/plan/procurement',
    name: 'common:route.planProcurement',
  },
  planProcurementDetail: {
    path: '/plan/procurement/:id',
    name: 'common:route.planProcurementDetail',
  },
  // eBalance に提出記録の無い計画の詳細 (spec procurement-plan-detail.md AC-PPD-028)。
  // 版 ID が無いので計画を業務キー (?targetDate=YYYY-MM-DD&submissionEntityCode=) で指す。
  // 静的 segment は `:id` より優先されるので版の詳細の route と衝突しない。
  planProcurementNoSubmissionRecord: {
    path: '/plan/procurement/no-submission-record',
    name: 'common:route.planProcurementNoSubmissionRecord',
  },
  planGenSales: { path: '/plan/gen-sales', name: 'common:route.planGenSales' },
  planGenSalesDetail: {
    path: '/plan/gen-sales/:id',
    name: 'common:route.planGenSalesDetail',
  },
  planDemandSuppression: {
    path: '/plan/demand-suppression',
    name: 'common:route.planDemandSuppression',
  },
  planSplitSupply: {
    path: '/plan/split-supply',
    name: 'common:route.planSplitSupply',
  },
  // 自社の通告値 1 通の詳細 (48 コマの確認・編集)。 通は id を持たないので、 通の識別と表示日を query に持つ
  planSplitSupplyDetail: {
    path: '/plan/split-supply/detail',
    name: 'common:route.planSplitSupplyDetail',
  },
  // balance
  balanceDemand: {
    path: '/balance/demand',
    name: 'common:route.balanceDemand',
  },
  balanceGeneration: {
    path: '/balance/generation',
    name: 'common:route.balanceGeneration',
  },
  balanceImputationPolicy: {
    path: '/balance/imputation-policy',
    name: 'common:route.balanceImputationPolicy',
  },
  balanceDemandDetail: {
    path: '/balance/demand-detail',
    name: 'common:route.balanceDemandDetail',
  },
  balanceGenerationDetail: {
    path: '/balance/generation-detail',
    name: 'common:route.balanceGenerationDetail',
  },
  // revenue
  revenueForecast: {
    path: '/admin/revenue-forecast',
    name: 'common:route.revenueForecast',
  },
  revenueInvoice: {
    path: '/admin/invoice',
    name: 'common:route.revenueInvoice',
  },
  // jukyu (需給情報)
  jukyuAreaBalance: {
    path: '/admin/area-balance',
    name: 'common:route.jukyuAreaBalance',
  },
  jukyuReserveRate: {
    path: '/admin/reserve-rate',
    name: 'common:route.jukyuReserveRate',
  },
  jukyuInterconnection: {
    path: '/admin/interconnection',
    name: 'common:route.jukyuInterconnection',
  },
  jukyuHjks: { path: '/admin/hjks', name: 'common:route.jukyuHjks' },
  // weather
  weatherForecast: {
    path: '/weather/forecast',
    name: 'common:route.weatherForecast',
  },
  // customer (顧客管理)
  // /admin/customer-info は顧客一覧へ転送するだけ (routes/index.tsx)
  customerInfo: {
    path: '/admin/customer-info',
    name: 'common:route.customerInfo',
  },
  customerList: {
    path: '/admin/customer-info/list',
    name: 'common:route.customerList',
  },
  customerContractors: {
    path: '/admin/customer-info/contractors',
    name: 'common:route.customerContractors',
  },
  customerContract: {
    path: '/admin/customer-info/contract',
    name: 'common:route.customerContract',
  },
  customerRate: {
    path: '/admin/customer-info/rate',
    name: 'common:route.customerRate',
  },
  customerSchedule: {
    path: '/admin/customer-info/schedule',
    name: 'common:route.customerSchedule',
  },
  // admin
  // システム管理トップ (カテゴリ + カードの入口画面)。8080 `admin/index.html` /
  // React mock `AdminHub` と同じ `/admin/hub`。`/admin` 直下は使わない
  // (menuGroups の prefix が `/admin` で、グループ判定と衝突するため)
  adminHub: {
    path: '/admin/hub',
    name: 'common:route.adminHub',
  },
  adminDatabase: {
    path: '/admin/database',
    name: 'common:route.adminDatabase',
  },
  adminRatePlan: {
    path: '/admin/rate-plan',
    name: 'common:route.adminRatePlan',
  },
  adminDemandGroups: {
    path: '/admin/demand-groups',
    name: 'common:route.adminDemandGroups',
  },
  adminOccto: { path: '/admin/occto-master', name: 'common:route.adminOccto' },
  adminPlantUnitMaster: {
    path: '/admin/plant-unit-master',
    name: 'common:route.adminPlantUnitMaster',
  },
  adminPlantUnitDetail: {
    path: '/admin/plant-unit-master/:id',
    name: 'common:route.adminPlantUnitDetail',
  },
  adminEquipment: {
    path: '/admin/equipment',
    name: 'common:route.adminEquipment',
  },
  adminLossRate: {
    path: '/admin/loss-rate',
    name: 'common:route.adminLossRate',
  },
  adminWeatherForecastPoints: {
    path: '/admin/weather-forecast-points',
    name: 'common:route.adminWeatherForecastPoints',
  },
  adminDemandCurve: {
    path: '/admin/demand-curve',
    name: 'common:route.adminDemandCurve',
  },
  // 需要想定設定 (spec demand/settings/index.md)。タブは `?tab=` で表す
  demandSettings: {
    path: '/demand/settings',
    name: 'common:route.demandSettings',
  },
  demandSingularDay: {
    path: '/demand/singular-day',
    name: 'common:route.demandSingularDay',
  },
  adminWorkflowTemplates: {
    path: '/admin/workflow-templates',
    name: 'common:route.adminWorkflowTemplates',
  },
  adminApprovalFlow: {
    path: '/admin/approval-flow',
    name: 'common:route.adminApprovalFlow',
  },
  adminBidLimits: {
    path: '/admin/bid-limits',
    name: 'common:route.adminBidLimits',
  },
  adminApprovalTasks: {
    path: '/admin/approval-tasks',
    name: 'common:route.adminApprovalTasks',
  },
  adminPlanAutoSubmit: {
    path: '/admin/plan-auto-submit',
    name: 'common:route.adminPlanAutoSubmit',
  },
  adminUsers: { path: '/admin/users', name: 'common:route.adminUsers' },
  adminLinkage: { path: '/admin/linkage', name: 'common:route.adminLinkage' },
  adminJepxMemberInfo: {
    path: '/admin/jepx-member-info',
    name: 'common:route.adminJepxMemberInfo',
  },
  adminCommLog: { path: '/admin/comm-log', name: 'common:route.adminCommLog' },
  adminNotificationChange: {
    path: '/admin/notification-change',
    name: 'common:route.adminNotificationChange',
  },
  adminNotificationSettings: {
    path: '/admin/notification-settings',
    name: 'common:route.adminNotificationSettings',
  },
  adminFipPremium: {
    path: '/admin/fip-premium',
    name: 'common:route.adminFipPremium',
  },
  adminIndirectTransmission: {
    path: '/admin/indirect-transmission',
    name: 'common:route.adminIndirectTransmission',
  },
  adminCapacityContribution: {
    path: '/admin/capacity-contribution',
    name: 'common:route.adminCapacityContribution',
  },
  // uploads (CSVアップロード)
  adminUploads: {
    path: '/admin/uploads',
    name: 'common:route.adminUploads',
  },
  adminUploadsSupply48Data: {
    path: '/admin/uploads/supply-48-data',
    name: 'common:route.adminUploadsSupply48Data',
  },
  adminUploadsDemandGroups: {
    path: '/admin/uploads/demand-groups',
    name: 'common:route.adminUploadsDemandGroups',
  },
  adminUploadsBilateralTrade: {
    path: '/admin/uploads/bilateral-trade',
    name: 'common:route.adminUploadsBilateralTrade',
  },
  adminUploadsCisContract: {
    path: '/admin/uploads/cis-contract',
    name: 'common:route.adminUploadsCisContract',
  },
  adminUploadsCustomerContract: {
    path: '/admin/uploads/customer-contract',
    name: 'common:route.adminUploadsCustomerContract',
  },
  adminUploadHistory: {
    path: '/admin/uploads/history',
    name: 'common:route.adminUploadHistory',
  },
  // settings
  settings: { path: '/settings', name: 'common:route.settings' },
  // announcements (お知らせ = リリース告知)
  announcements: {
    path: '/announcements',
    name: 'common:route.announcements',
  },
  announcementDetail: {
    path: '/announcements/:announcementId',
    name: 'common:route.announcementDetail',
  },
} as const

/**
 * 需要想定 (単日) の旧 URL (断面セグメント付き)。query を保ったまま断面なしの
 * `demandForecastDaily` へ redirect する (AC-DFD-000、断面の部分は使わない)。routePaths の key に
 * しない (menu / i18n の対象外、routes/index.tsx の redirect だけが参照する)。
 */
export const DEMAND_FORECAST_DAILY_LEGACY_PATH =
  '/demand/forecast-daily/:section'
